export enum LiftOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
